import React from 'react';
import { formatBilletInput } from '@portal/utils/format';
import { Input } from 'antd';
import { translate } from '@portal/services/i18n';
import useReduxState from '@portal/hooks/useReduxState';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface IProps {
  code: string;
  setCode: (value: string) => void;
  handleBilletCodeSubmit: () => void;
}

const BilletSlipCode = ({ code, setCode, handleBilletCodeSubmit }: IProps) => {
  const {
    theme: { currentTheme },
  } = useReduxState();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      handleBilletCodeSubmit();
    }
  };

  return (
    <div className="bank-slip">
      <ThemedText variant="body" className="bank-slip__instruction">
        {translate('PAGES.HOME.PAY.BILLET_CODE_INSTRUCTION.INSERT_THE')}{' '}
        <strong>
          {translate('PAGES.HOME.PAY.BILLET_CODE_INSTRUCTION.BILLET_CODE')}
        </strong>{' '}
        {translate('PAGES.HOME.PAY.BILLET_CODE_INSTRUCTION.WISH_TO_PAY')}
      </ThemedText>
      <div
        className="bank-slip__textarea"
        style={{ borderTop: `2px solid ${currentTheme.borderColor}` }}
      >
        <Input.TextArea
          className="bank-slip__textarea__component"
          autoFocus
          rows={4}
          onChange={(e) => setCode(formatBilletInput(e.target.value))}
          value={code}
          placeholder="00000.00000 00000.000000&#10;00000.000000 0 00000000000000"
          onKeyDown={handleKeyDown}
          maxLength={58}
        />
      </div>
    </div>
  );
};

export default BilletSlipCode;
